module.exports = __webpack_public_path__ + "static/social-directed-dcd23941ce1da89be28bb2da24fb1acc.svg";